import axios from "axios";
import { PORT } from "./../config";

const API_BASE_URL = PORT;

const defaultOptions = {
    baseURL: API_BASE_URL,
    timeout: 180000,
    headers: {
        "Content-Type": "application/json",
    },
    validateStatus: function (status) {
        return status < 400; // Resolve only if the status code is less than 400
    },
};

const axiosInstance = axios.create(defaultOptions);

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? `Token ${window.localStorage.token}` : "";
    return config;
});

class BaseApi {
    constructor() {
        this.apiCore = axiosInstance;
        this.baseURL = new URL(API_BASE_URL);
    }

    async get(endpoint, queryParams = {}, responseType) {
        const url = new URL(endpoint, this.baseURL);

        const response = await this.apiCore.get(url.toString(),{
            params: queryParams,
            responseType: responseType
        });

        if (response.status >= 400) {
            throw new Error('Network response was not ok');
        }

        return response.data;
    }

    async post(endpoint, data) {
        const url = new URL(endpoint, this.baseURL);

        const response = await this.apiCore.post(url.toString(), data);

        if (response.status >= 400) {
            throw new Error('Network response was not ok');
        }

        return response.data;
    }

    async put(endpoint, data) {
        const url = new URL(endpoint, this.baseURL);

        const response = await this.apiCore.put(url.toString(), data);

        if (response.status >= 400) {
            throw new Error('Network response was not ok');
        }

        return response.data;
    }

    async del(endpoint) {
        const url = new URL(endpoint, this.baseURL);

        const response = await this.apiCore.delete(url.toString());

        if (response.status >= 400) {
            throw new Error('Network response was not ok');
        }

        return response.data;
    }
}

export const APIMETHOD = new BaseApi();
